// extracted by mini-css-extract-plugin
export default {"container":"Animal_container__AGIhM","species-container":"Animal_species-container__YsRYq","quota":"Animal_quota__JKkpm","ring":"Animal_ring__vGl8l"};